import {useContext} from "react";
import {IRootStore} from "./rootStore";
import {StateContext} from "./rootStore";

export const useStores = (): IRootStore => useContext(StateContext);
